export default __webpack_public_path__ + "static/gw-729855e562ea8a9c2c8a01e9aa05c604.svg";